import React from 'react'
import { Link } from 'react-router-dom'
import Button, { ButtonProps } from '@material-ui/core/Button'
import styles from './ButtonLink.module.scss'

interface Props extends ButtonProps {
  to: string
}

export const ButtonLink = ({ to, ...rest }: Props) => (
  <Link className={styles.root} to={to}>
    <Button {...rest} />
  </Link>
)
